module.exports = __webpack_public_path__ + "img/nImage.3b18979b.png";